export default __webpack_public_path__ + "static/media/bannerSmall8.0eeb1095.png";